<!-- ========== Left Sidebar Start ========== -->
<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<!-- Left Sidebar End -->
<!-- Navbar Start -->
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>
<!-- end Navbar -->
<!-- Footer Start -->
<app-footer></app-footer>
<!-- end Footer -->
@if (security.permitted('contacts', 'contact list', 'view')) {
  <div class="content-page bg-gray text-dark">
    <div class="content p-1">
      <h5 class="px-1 text-capitalize text-dark">{{this.fixedRole ? this.fixedRoleName : 'Contacts'}}</h5>
      <div class="col-md-12 p-1">
        <div class="rounded">
          <div class="list-bar">
            <form [formGroup]="form" class="form-row">
              <div class="form-group col">
                <div class="input-group">
                  <div class="input-group-append">
                    <span class="input-group-text"><span class="mdi mdi-magnify search-icon"></span></span>
                  </div>
                  <input autocomplete="off" type="search" class="form-control" id="search" autofocus="true" formControlName="inquiry" />
                </div>
              </div>
              @if (!fixedRole) {
                <div class="form-group col">
                  <select class="form-control" name="role" id="role-filter" formControlName="role">
                    <option value="">All roles</option>
                    @for (role of roles; track role) {
                      <option [value]="role.key">{{role.type}}</option>
                    }
                  </select>
                </div>
              }
              <div class="form-group col">
                <date-span [verb]="'Modified'" [default]="FILTER_SPAN_KEY" (chosen)="spanned($event)"></date-span>
              </div>
            </form>
            <div class="d-flex justify-content-end">
              @if (security.permitted('contacts', 'contact list', 'add')) {
                <button class="btn btn-primary shadow mr-2" [disabled]="loading" title="Add"
                  (click)="createContact()">
                  @if (!loading) {
                    <span class="dripicons-plus h4"></span>
                  }
                  @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                  }
                </button>
              }
            </div>
          </div>
          <div id="listing" class="col-md-12 tableFixHead" (scroll)="scrolled($event)">
            @if (contacts) {
              <table class="table table-sm table-hover table-striped table-responsive-sm" id="contactTable">
                <thead>
                  <tr>
                    <th (click)="sort('name')" class="sorted" scope="col">
                      {{ words[language]['name'] }}
                      @if (sortedAsc('name')) {
                        <span class="dripicons-chevron-up text-dark sort-icon"
                        ></span>
                      }
                      @if (sortedDesc('name')) {
                        <span class="dripicons-chevron-down text-dark sort-icon"
                        ></span>
                      }
                    </th>
                    <th scope="col">{{ words[language]['communications'] }}</th>
                    <th scope="col">{{ words[language]['phone'] }}</th>
                    <th (click)="sort('updatedAt')" class="sorted" scope="col">
                      {{ words[language]['updatedAt'] }}
                      @if (sortedAsc('updatedAt')) {
                        <span class="dripicons-chevron-up text-dark sort-icon"
                        ></span>
                      }
                      @if (sortedDesc('updatedAt')) {
                        <span class="dripicons-chevron-down text-dark sort-icon"
                        ></span>
                      }
                    </th>
                    <th scope="col">{{ words[language]['location'] }}</th>
                    @if (!fixedRole) {
                      <th scope="col">Roles</th>
                    }
                    <th class="text-right" scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (contact of contacts; track contact) {
                    <tr class="clickable">
                      <td scope="row" [routerLink]="[contact.id]">{{contact.name}}</td>
                      <td>
                        <a href="{{contact.isIndividual ? 'mailto:' : ''}}{{contact.comms}}"
                        (click)="$event.stopPropagation()" target="_blank">{{contact.comms}}</a>
                      </td>
                      <td><a href="tel:{{contact.phone}}" (click)="$event.stopPropagation()">{{contact.phone | phone}}</a></td>
                      <td [routerLink]="[contact.id]">{{contact.updatedAt | date:'shortDate'}}</td>
                      <td [routerLink]="[contact.id]">
                        @if (contact.zipCode) {
                          <span>{{contact.city}}, {{contact.state}} {{contact.zipCode}}</span>
                        }
                      </td>
                      @if (!fixedRole) {
                        <td [routerLink]="[contact.id]">
                          @if (contact.roles) {
                            <span>{{contact.roles}}</span>
                          }
                        </td>
                      }
                      <!-- actions -->
                      <td class="text-right actions">
                        <!-- delete -->
                        @if (security.permitted('contacts', 'contact list', 'delete')) {
                          <button title="Delete" class="btn btn-sm btn-link" (click)="setContactIdForDelete($event, contact.id)" data-target="#deleteContactModal" data-toggle="modal">
                            @if (!loading) {
                              <span class="dripicons-trash text-danger"></span>
                            }
                            @if (loading) {
                              <span class="spinner-grow spinner-grow-sm" role="status"></span>
                            }
                          </button>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            }
          </div>
        </div>
        <p class="list-footer text-muted">{{displayed | number: '1.0-0'}} / {{records | number: '1.0-0'}}
        {{words[language][type]}} {{words[language]['displayed']}}</p>
      </div>
    </div>
  </div>
}

<!-- modals -->
<!-- delete modal -->
<div class="modal fade" id="deleteContactModal" tabindex="-1" data-backdrop="static" role="dialog"
  aria-labelledby="mySmallModalLabel">
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
        <span class="uil-trash-alt text-danger display-1"></span>
        <h3 class="text-danger w-100 text-center">{{words[language][ 'delete' ] }}</h3>
        <span class="text-dark my-1 text-center">{{words[language][ 'deleteContact' ] }}</span>
        <button class="btn btn-danger mt-2" (click)="deleteContact()" [disabled]="loading">
          @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
          }
        Yes</button>
        <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="btn-close-modal-delete">No</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- warning modal -->
<div class="modal fade" id="deactivateModal" data-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel">
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
        <span class="dripicons-cross text-danger display-1"></span>
        <h4 class="text-danger w-100 text-center">{{words[language][ 'deactivate' ] }}</h4>
        <span class="text-dark my-1 text-center">{{words[language][ 'deactivateContact' ] }}</span>
        <button class="btn btn-danger mt-2" (click)="deleteContact()" [disabled]="loading">
          @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
          }
        Yes</button>
        <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal"
        id="btn-close-modal-deactivate">No</button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
